import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  chatBotDisplay: false,
  chatBotTriggerMode: '',
  chatBotApplicationId: '',
  botType: '',
  error: false,
  chatBotAsync: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_POST_CHATBOT_ELIGIBILITY:
      return {
        ...state, isLoading: true, chatBotDisplay: false, error: false,
      };
    case types.POST_CHATBOT_ELIGIBILITY_RESPONSE: {
      return {
        ...state,
        isLoading: false,
        chatBotDisplay: (action.payload.result === 'ELIGIBLE'),
        chatBotTriggerMode: action.payload.trigger_mode,
        chatBotApplicationId: action.payload.bot_application_id,
        botType: action.payload.bot_type,
        chatBotAsync: action.payload.async,
        error: false,
      };
    }
    case types.POST_CHATBOT_ELIGIBILITY_ERROR:
      return {
        ...state, isLoading: false, error: true, chatBotDisplay: false,
      };
    case types.POST_CHATBOT_ELIGIBILITY_FALSE:
    case types.REQUEST_BY_EMAIL:
      return { ...state, chatBotDisplay: false };
    case types.CONTACT_LOCATION_CHANGE:
      // Making chatBot Eligibility False when user goes to call and email page
      if (action.payload.pageName === 'callUs' || action.payload.pageName === 'email') {
        return { ...state, chatBotDisplay: false };
      }
      return state;
    default:
      return state;
  }
}
